import script from "./BasicInfoForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicInfoForm.vue?vue&type=script&setup=true&lang=ts"

import "./BasicInfoForm.vue?vue&type=style&index=0&id=d9e1b7e6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9e1b7e6"]])

export default __exports__